import { StyledPricingSection } from "./styles";
import { ROUTES } from "../../../constant/routes";

const PricingSection = () => {
  return (
    <StyledPricingSection
      className="section-padding  flex-col align-center"
      id="pricing"
    >
      <div
        className="panel"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "28px",
          textAlign: "center",
          flexDirection: "column",
        }}
      >
        <span className="section-label">Pricing</span>

        <h2 style={{ margin: "8px 0 4px" }}>
          Starting from <span className="gradient-text">£49</span>/month
        </h2>

        <p
          style={{
            margin: 0,
            color: "#6f687e",
          }}
        >
          One workspace. Unlimited customer connections. 14-day free trial no
          credit card required.
        </p>

        <a
          className="btn btn-primary"
          href={ROUTES.SIGNUP}
          rel="noopener noreferrer"
          style={{ marginTop: "12px" }}
        >
          Start free trial
        </a>
      </div>
    </StyledPricingSection>
  );
};

export default PricingSection;
